import { Link } from 'react-router-dom'
import { PhoneMockup } from './PhoneMockup'

const OPEN_SIGNUP = import.meta.env.VITE_OPEN_SIGNUP !== 'false'

const CalendarScreen = () => (
  <div className="px-3 py-3">
    <div className="flex items-center justify-between mb-3">
      <span className="text-[11px] font-bold text-text-primary">April 2026</span>
      <span className="text-[10px] text-text-muted">← →</span>
    </div>
    <div className="grid grid-cols-7 gap-0.5 mb-2">
      {['S','M','T','W','T','F','S'].map((d,i) => (
        <div key={i} className="text-center text-[9px] text-text-muted font-medium">{d}</div>
      ))}
    </div>
    <div className="grid grid-cols-7 gap-0.5">
      {Array.from({ length: 30 }, (_, i) => i + 1).map((d) => (
        <div key={d} className={`aspect-square rounded-md flex items-center justify-center text-[10px] font-medium
          ${d === 18 ? 'bg-primary text-white' : d === 22 || d === 25 ? 'bg-primary/10 text-primary' : 'text-text-secondary'}`}>
          {d}
        </div>
      ))}
    </div>
    <div className="mt-3 space-y-1.5">
      {[
        { label: 'Soccer practice', color: '#f43f5e', time: '4:00 PM' },
        { label: 'Dentist appt', color: '#0ea5e9', time: '10:30 AM' },
        { label: 'Grocery run', color: '#10b981', time: '6:00 PM' },
      ].map(({ label, color, time }) => (
        <div key={label} className="flex items-center gap-2 bg-white rounded-lg px-2 py-1.5 shadow-sm">
          <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: color }} />
          <span className="text-[10px] font-medium text-text-primary flex-1">{label}</span>
          <span className="text-[9px] text-text-muted">{time}</span>
        </div>
      ))}
    </div>
  </div>
)

export const HeroSection = () => (
  <section id="top" className="relative min-h-screen flex flex-col justify-center pt-20 pb-16 px-4 overflow-hidden">
    {/* Background gradient blobs */}
    <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" />
    <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-primary/5 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none" />

    <div className="max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      {/* Copy */}
      <div className="text-center lg:text-left">
        <div className="inline-flex items-center gap-2 bg-primary-light text-primary text-xs font-semibold px-3 py-1.5 rounded-full mb-6 animate-fade-in">
          <span className="w-1.5 h-1.5 bg-primary rounded-full animate-pulse" />
          7-day free trial — no credit card required
        </div>

        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-text-primary leading-[1.1] mb-6 animate-fade-up animation-delay-100">
          Keep your whole<br />
          household{' '}
          <span className="text-primary italic">in sync.</span>
        </h1>

        <p className="text-base sm:text-lg text-text-secondary leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8 animate-fade-up animation-delay-200">
          One app for family calendars, chores, shopping lists, meal planning,
          budgets, and more. Works offline. Built for real family life.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 animate-fade-up animation-delay-300">
          {OPEN_SIGNUP ? (
            <Link
              to="/signup"
              className="w-full sm:w-auto bg-primary text-white text-sm font-semibold px-8 py-4 rounded-2xl hover:bg-primary/90 transition-all shadow-xl shadow-primary/25 hover:shadow-primary/40 hover:-translate-y-0.5"
            >
              Start free trial
            </Link>
          ) : (
            <a
              href="#waitlist"
              className="w-full sm:w-auto bg-primary text-white text-sm font-semibold px-8 py-4 rounded-2xl hover:bg-primary/90 transition-all shadow-xl shadow-primary/25"
            >
              Join the waitlist
            </a>
          )}
          <a
            href="#how-it-works"
            className="w-full sm:w-auto bg-white border border-border text-text-primary text-sm font-semibold px-8 py-4 rounded-2xl hover:border-primary/40 transition-colors"
          >
            See how it works
          </a>
        </div>

        <p className="mt-4 text-xs text-text-muted animate-fade-up animation-delay-400">
          Free plan available · Cancel anytime
        </p>

        {/* Social proof avatars */}
        <div className="mt-8 flex items-center justify-center lg:justify-start gap-3 animate-fade-up animation-delay-500">
          <div className="flex -space-x-2">
            {['#f43f5e','#0ea5e9','#10b981','#f59e0b','#8b5cf6'].map((c,i) => (
              <div key={i} className="w-8 h-8 rounded-full border-2 border-white flex-shrink-0" style={{ backgroundColor: c }} />
            ))}
          </div>
          <p className="text-xs text-text-secondary">
            Join <span className="font-semibold text-text-primary">early families</span> using DoorChart
          </p>
        </div>
      </div>

      {/* Phone mockup */}
      <div className="flex justify-center lg:justify-end animate-fade-up animation-delay-300">
        <div className="animate-float">
          <PhoneMockup>
            <CalendarScreen />
          </PhoneMockup>
        </div>
      </div>
    </div>
  </section>
)
